import React, { useContext, useMemo } from "react";
import { ProduitInterface } from "dataProvider/Produit";
import { IntlContext } from "context";
import { Link } from "react-router-dom";
import Table from "./Table";

export interface ValeursNutritionnellesProps {
    produit: ProduitInterface | any;
    more?: {
        visible?: boolean;
        onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    };
}
const ValeursNutritionnelles: React.FC<ValeursNutritionnellesProps> = ({ produit, more = { visible: false } }) => {
    const intl = useContext(IntlContext);
    interface UniteExpOrderInterface {
        idUnitExp: string;
        idSource: string;
    }

    const renderTables = useMemo(() => {
        let uniteExpOrder: UniteExpOrderInterface[] = [];

        const constituants = (produit?.produit_constituants || []).reduce(
            (memo: HashMap<HashMap<Array<any>>>, constituant: any) => {
                const idUnitExp = "" + constituant?.id_uniteexpression_vn;
                const idSource = "" + constituant?.id_source;

                if (!memo[idUnitExp]) {
                    memo[idUnitExp] = {};
                }

                if (!memo[idUnitExp][idSource]) {
                    memo[idUnitExp][idSource] = [];
                    uniteExpOrder.push({
                        idUnitExp,
                        idSource,
                    });
                }

                memo[idUnitExp][idSource].push(constituant);

                return memo;
            },
            {}
        );

        return uniteExpOrder.reduce((memo1: any, uniteExpOrderItem: UniteExpOrderInterface, index: number) => {
            memo1.push(
                <Table
                    key={index}
                    constituants={constituants[uniteExpOrderItem.idUnitExp][uniteExpOrderItem.idSource]}
                    visible={index === 0 ? true : more.visible}
                />
            );

            return memo1;
        }, []);
    }, [more.visible, produit?.produit_constituants]);

    if (!(produit?.produit_constituants || []).length) {
        return null;
    }

    return (
        <div className="product-informations__block">
            <h2 className="information__title">{intl.formatMessage("produit.fiche.label.valeurs_nutritionnelles")}</h2>
            {renderTables}
            {renderTables.length > 1 && (
                <div className={`information-list-ingredients-more ${more.visible ? "hidden" : ""}`}>
                    <Link
                        to="#"
                        className="cta cta--link cta-ingredients-more"
                        title={intl.formatMessage("generic.see_all")}
                        onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                            more?.onClick && more.onClick(e);
                        }}
                    >
                        {intl.formatMessage("generic.see_all")}
                    </Link>
                </div>
            )}
        </div>
    );
};

export default ValeursNutritionnelles;
